<template>
    <transition name="slide-right">
        <div id="v-download" v-if="downAmount">
            <v-btn class="icon-btn big" @click="all_picture_download">
                <i class="v-icon" v-html="$P.downloadIcon"></i>
                <span>{{ downAmount }}</span>
            </v-btn>
        </div>
    </transition>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { downloads } from "@/api/interface.js";
import { create_download, download_picture } from "@/utils/util";

export default {
    name: "v-download",
    props: {
        data: {
            type: Object,
            required: false
        }
    },
    data() {
        return {};
    },
    computed: {
        ...mapState("download", ["downAmount", "downCount"])
    },
    components: {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {
        ...mapMutations("download", ["updateDownAmount", "updateDownCount"]),
        ...mapMutations("triggerEvtents", ["updateSnackbar"]),
        all_picture_download() {
            this.downCount.forEach((item, i) => {
                // 执行全部下载
                setTimeout(async () => {
                    this.$P.$emit("createAllDownload", item.postId);
                }, i * 3000);

                //  当完成所有下载
                if (i >= this.downCount.length - 1) {
                    this.updateDownCount(false);
                    //  下载成功，取消选定

                    this.$P.$emit("successDownload", false);
                    this.updateSnackbar(this.$TL.allDownloadSuccess);
                    this.updateDownAmount("");
                }
            });
        }
    }
};
</script>

<style lang="scss">
#v-download {
    bottom: 176px;

    .v-btn {
        background-color: #2874e5;
    }

    i {
        font-size: 26px;
        color: $color-white;
    }

    .v-btn__content span {
        font-size: 12px;
        display: inline-block;
        min-width: 20px;
        height: 20px;
        border-radius: 20px;
        padding: 2px 5px;
        background-color: #ff4d4f;
        color: $color-white;
        line-height: 1.2em;

        position: absolute;
        top: -4px;
        left: 32px;
    }
}
</style>
